import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { apiFetch, ApiClientError } from '@/lib/api-client'
import { Logo } from '@/components/Logo'

export function VerifyEmailPage() {
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''
  const [status, setStatus] = useState<'verifying' | 'ok' | 'error'>('verifying')
  const [message, setMessage] = useState<string | null>(null)

  useEffect(() => {
    if (!token) {
      setStatus('error')
      setMessage('Missing verification token.')
      return
    }
    apiFetch('/auth/verify-email', {
      method: 'POST',
      body: { token },
      skipAuth: true,
    })
      .then(() => setStatus('ok'))
      .catch((err: unknown) => {
        setStatus('error')
        setMessage(err instanceof ApiClientError ? err.message : 'Unexpected error.')
      })
  }, [token])

  return (
    <div className="flex h-full items-center justify-center bg-gradient-to-b from-ovation-paper to-white px-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>
        <div className="rounded-xl border border-ovation-ink/10 bg-white p-7 text-center shadow-xl shadow-ovation-ink/5">
          {status === 'verifying' && (
            <>
              <h1 className="font-display text-2xl">Verifying your email…</h1>
              <p className="mt-2 text-sm text-ovation-muted">Hold on a moment.</p>
            </>
          )}
          {status === 'ok' && (
            <>
              <h1 className="font-display text-2xl text-emerald-700">
                Email verified
              </h1>
              <p className="mt-2 text-sm text-ovation-muted">
                You're all set. Sign in to continue.
              </p>
              <Link
                to="/login"
                className="mt-4 inline-block rounded-md bg-ovation-ink px-4 py-2 text-sm font-medium text-ovation-paper hover:bg-ovation-ink/90"
              >
                Sign in
              </Link>
            </>
          )}
          {status === 'error' && (
            <>
              <h1 className="font-display text-2xl text-red-700">
                Verification failed
              </h1>
              <p className="mt-2 text-sm text-ovation-muted">
                {message ?? 'The link is invalid or has expired.'}
              </p>
              <Link
                to="/login"
                className="mt-4 inline-block text-sm text-ovation-ink hover:underline"
              >
                Back to sign in
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
